import { render, staticRenderFns } from "./SharedProductPrice.template.vue?vue&type=template&id=3c666750&scoped=true&"
var script = {}
import style0 from "./SharedProductPrice.template.vue?vue&type=style&index=0&id=3c666750&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c666750",
  null
  
)

export default component.exports